import { useLazyDownloadStatementTitlesDocumentQuery } from "../../../redux/api/reconciliationsApiSlice";
import { Button, Checkbox, Form, message, Modal, Space, Typography } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { isEmpty } from "lodash";
import { useStatementsTitlesTable } from "../../../context/StatementTitlesTableContext";

const { Text } = Typography;

export const DownloadStatementTitlesButton = () => {

  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);

  const [download, { isLoading }] = useLazyDownloadStatementTitlesDocumentQuery();

  const {
    getParamsForApiRequest
  } = useStatementsTitlesTable();

  return (
    <>
      <Modal
        open={open}
        title={"Download dei titoli"}
        onCancel={() => setOpen(false)}
        okText={"Conferma"}
        onOk={() => {
          form?.validateFields().then(({ hasSorting, hasFilters }) => {
            let queryArgs = {};
            let { ordering, ...filters} = getParamsForApiRequest();
            if (hasSorting) {
              queryArgs = { ...(!isEmpty(ordering) && { ordering }) };
            }
            if (hasFilters) {
              queryArgs = {
                ...queryArgs,
                ...filters
              };
            }
            download(queryArgs)
              .unwrap()
              .then(() => {
                setOpen(false);
              })
              .catch((err) => {
                console.error("could not download statement titles due to an error: ", err);
                message.error("Errore nel download del file");
              });
          });
        }}>
        <Text>
          Selezionare le opzioni di interesse per la generazione del file dei titoli in formato .xlsx. Quindi
          premere il pulsante "Conferma" per effettuare il download del file.
        </Text>
        <Form
          name={"downloadTitles"}
          form={form}
          style={{ marginTop: "1rem" }}
          initialValues={{ hasSorting: true, hasFilters: true }}>
          <Form.Item
            name={"hasSorting"}
            valuePropName={"checked"}
            style={{ marginBottom: 0 }}>
            <Checkbox>
              <Space direction={"vertical"} size={0}>
                <Text strong={true}>Ordinamenti attivi</Text>
                <Text>Mantiene gli ordinamenti per colonna impostati in tabella</Text>
              </Space>
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={"hasFilters"}
            style={{ marginBottom: 0 }}
            valuePropName={"checked"}>
            <Checkbox>
              <Space direction={"vertical"} size={0}>
                <Text strong={true}>Filtri attivi</Text>
                <Text>Mantiene i filtri attivi per colonna impostati in tabella</Text>
              </Space>
            </Checkbox>
          </Form.Item>
        </Form>
      </Modal>
      <Button
        loading={isLoading}
        disabled={isLoading}
        icon={<DownloadOutlined />}
        type={"link"}
        onClick={() => {
          /*setOpen(true);*/
          download({})
              .unwrap()
              .then(() => {
                setOpen(false);
              })
              .catch((err) => {
                console.error("could not download statement titles due to an error: ", err);
                message.error("Errore nel download del file");
              });
        }}>
        Scarica titoli
      </Button>
    </>

  );
};

export default DownloadStatementTitlesButton;